/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Header from '../Header'
import styles from './FeatureSubscriptions.css'
import {
  cancelFeatureSubscription,
  hideCancelSubscriptionModal,
  onClickCancelSubscriptionModal
} from 'actions/setting/billing'
import CancelFeatureSubscriptionModal from 'components/CancelFeatureSubscriptionModal'

class FeatureSubscriptions extends Component {
  render () {
    const {
      countFeatureSubscription,
      featureSubscriptionStatus,
      showCancelFeatureSubscriptionModal,
      cancelFeatureSubscriptionModalData,
      showLoadingSpinnerPage
    } = this.props
    return (!showLoadingSpinnerPage &&
      <div>
        <Header title='feature subscriptions' />
        {
          countFeatureSubscription > 0 && featureSubscriptionStatus.map((feature) => {
            if (feature.is_active) {
              return (
                <div className={styles['mb-20px']} key={feature.id}>
                  <div className={`row ${styles['feature-row']}`}>
                    <div className='col-xs-6'>{feature.name}</div>
                    <div className='col-xs-6'>
                      {
                        feature.is_subscribing && feature.name !== 'Loyalty' && <div>
                          <p className={`text-right ${styles['btn-link-cancel']}`}>
                            <button className='btn btn-link' onClick={() => { this._showModal(feature) }}>Cancel Subscription</button>
                          </p>
                        </div>
                      }
                      {
                        !feature.is_subscribing && <div>
                          <p className={`text-right ${styles['btn-link-cancel']} ${styles['active-until-text']}`}>Active until {moment(feature.expiration_date).format('DD MMM YYYY')}</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              )
            }
          })
        }
        {
          countFeatureSubscription === 0 && <div>
            <i>None</i>
          </div>
        }
        <CancelFeatureSubscriptionModal
          showModal={showCancelFeatureSubscriptionModal}
          featureName={cancelFeatureSubscriptionModalData.name}
          hideModal={this._hideModal}
          expirationDate={cancelFeatureSubscriptionModalData.expirationDate}
          cancelSubscription={() => { this._cancelSubscription(cancelFeatureSubscriptionModalData.name) }}
        />
      </div>
    )
  }

  _showModal = (feature) => {
    let featureSubscription = {
      name: feature.name,
      expirationDate: moment(feature.expiration_date).format('DD MMM YYYY')
    }
    this.props.dispatch(onClickCancelSubscriptionModal(featureSubscription))
  }

  _hideModal = () => {
    this.props.dispatch(hideCancelSubscriptionModal())
  }

  _cancelSubscription = (featureName) => {
    let {featureSubscriptionStatus, outletMinMaxDate} = this.props
    const feature = {
      feature_name: featureName
    }
    this.props.dispatch(cancelFeatureSubscription(feature, featureSubscriptionStatus, outletMinMaxDate))
  }
}

function mapStateToProps (state) {
  const {featureSubscriptionStatus, countFeatureSubscription, showCancelFeatureSubscriptionModal, cancelFeatureSubscriptionModalData, outletMinMaxDate} = state.setting.billing
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    featureSubscriptionStatus,
    countFeatureSubscription,
    showCancelFeatureSubscriptionModal,
    cancelFeatureSubscriptionModalData,
    outletMinMaxDate,
    showLoadingSpinnerPage
  }
}

export default connect(mapStateToProps)(FeatureSubscriptions)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/FeatureSubscriptions/FeatureSubscriptions.js